export default {
    CzechRepublic: "Czech Republic",
};